export const LOAD_EVENTS_LIMIT = 20;
